
// 中国移动广东公司客户入网协议
import { ref, onMounted, defineComponent } from "vue";
import { getProtocol } from "@/utils/api"

export default defineComponent({
    name: "toast",
    props: {
        type: {
            type: String,
            default: "",
        },
    },
    setup(protos, page) {
        const storeTitleKey = "protocol:title:" + protos.type
        const storeHtmlKey = "protocol:html:" + protos.type

        const visible = ref(false);
        const html = ref('')
        const title = ref('')
        const fetchBody = async () => {

            const rsp = await getProtocol(protos.type)
            if (rsp.result == 0) {
                html.value = rsp.data.html
                title.value = rsp.data.title
                localStorage.setItem(storeHtmlKey, rsp.data.html)
                localStorage.setItem(storeTitleKey, rsp.data.title)
            } else {
                console.log(rsp)
            }
        }
        const onClose = () => {
            page.emit('onClose', {})
            page.emit
        }
        onMounted(() => {
            const cacheHtml = localStorage.getItem(storeHtmlKey)
            const cacheTitle = localStorage.getItem(storeTitleKey)
            if (cacheHtml && cacheTitle) {
                html.value = cacheHtml
                title.value = cacheTitle
            } 
            fetchBody()
        });
        return {
            visible,
            html,
            title,
            onClose
        };
    },
})
